import DataTable, {TableAction, TableColumn} from '../../../../shared/components/DataTable'
import {ICurrencyModel} from './CurrencyModel'

type Props = {
  data: ICurrencyModel[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  onEdit?: (currency: ICurrencyModel) => void
  onDelete?: (currency: ICurrencyModel) => void
  loading?: boolean
}
export const CurrencyTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onDelete,
  loading = false,
}) => {
  const currencyColumns: TableColumn<ICurrencyModel>[] = [
    {
      key: 'currencyAbbreviation',
      label: 'Döviz Kısaltması',
      className: 'fw-semibold',
    },
    {key: 'exchangeRate', label: 'Kur'},
    {key: 'country', label: 'Ülke'},
  ]

  const currencyActions: TableAction<ICurrencyModel>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: (currency) => onEdit?.(currency),
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: (currency) => onDelete?.(currency),
    },
  ]

  return (
    <DataTable
      data={data}
      columns={currencyColumns}
      actions={currencyActions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      loading={loading}
      emptyMessage='Henüz Döviz bulunamadı'
    />
  )
}
